<template>
    <v-dialog v-model="isModalShowing" persistent width="450">
        <template v-slot:activator="{ on }">
            <span v-on="on">
                <slot />
            </span>
        </template>
        <v-card data-test="call-list-modal">
            <v-card-text class="message-type-section">
                <div class="message-type-container">
                    <label class="message-type-option" :class="{ active: messageType === false }">
                        <input 
                            type="radio" 
                            name="messageType" 
                            v-model="messageType"
                            id="link" 
                            :value="false"
                            class="message-type-radio"
                        >
                        <span class="message-type-label">{{ $t('modals.findByNumbersModal.byLink') }}</span>
                    </label>
                    <label class="message-type-option" :class="{ active: messageType === true }">
                        <input 
                            type="radio" 
                            name="messageType" 
                            v-model="messageType"
                            id="response" 
                            :value="true"
                            class="message-type-radio"
                        >
                        <span class="message-type-label">{{ $t('modals.findByNumbersModal.byResponse') }}</span>
                    </label>
                    <v-select
                        v-model="picked"
                        :items="languageItems"
                        item-text="text"
                        item-value="value"
                        rounded
                        filled
                        dense
                        hide-details
                        style="max-width: 120px; font-size: 12px; margin-left: auto;"
                    ></v-select>
                </div>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-text>
                <input 
                    type="text"
                    class="input-group-field"
                    v-model="newNumbers"
                    @keyup.enter="addNumber"
                    :placeholder="$t('modals.findByNumbersModal.addNumberPlaceholder')"
                    style="font-weight: 500;text-align:center;"
                >
            </v-card-text>
            <v-container class="numbers-container">
                <!-- <v-alert
                    v-if="numbers.length === 0"
                    type="info"
                    text
                    dense
                    class="empty-state-alert"
                >No numbers added yet. Enter a phone number above
                </v-alert> -->
                <div 
                    class="number-item"
                    v-for="(number, i) in numbers"
                    :key="i"
                >
                    <span class="number-text">{{ number }}</span>
                    <v-btn 
                        class="remove-number-btn" 
                        icon 
                        x-small 
                        @click="removeNumber(number)"
                    >
                        <span class="remove-x">×</span>
                    </v-btn>
                </div>
            </v-container>
            <v-divider></v-divider>
            <v-card-actions>
                <v-btn medium text @click="cancelModal">{{ $t('modals.findByNumbersModal.cancel') }}</v-btn>
                <v-spacer />
                <v-btn medium @click="commitAndSubmitNumbers" color="primary">{{ $t('modals.findByNumbersModal.sendSms') }}</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script lang="js">
import Vue from 'vue'
import store from '@/store'
import {eventBus} from "@/main";

export default Vue.extend({
    data() {
        return {
            isModalShowing: false,
            numbers: [],
            newNumbers: '',
            messageType: false,
            languageValues: ['English', 'Spanish', 'French', 'Mandarin', 'German', 'Italian'],
        }
    },
    methods: {
        openModal() {
            this.isModalShowing = true
        },
        cancelModal() {
            this.isModalShowing = false
            window.location.reload()
        },
        addNumber() {
            if (this.numbers) {
                 if(this.newNumbers[0] == '+'){ //if international
                    this.numbers.push(
                        this.newNumbers,
                    );
                }
                else{ //else domestic
                    this.newNumbers = '+1' + this.newNumbers
                    this.numbers.push(
                        this.newNumbers
                    )
                }
                this.newNumbers = '';
            }
        },
        removeNumber(number) {
            const index = this.numbers.indexOf(number);
            if (index !== -1) {
                this.numbers.splice(index, 1);
            }
        },
        commitAndSubmitNumbers() {
            eventBus.$emit('startNumbersSearch', this.numbers)
            store.commit('location/callList', this.numbers)
            store.commit('location/isResponse', this.messageType)
            store.dispatch('location/requestMultipleLocations')
            this.isModalShowing = false
        },
    },
    watch: {
        isModalShowing(isOpen) {
            if (isOpen) {
                const lang = this.smsLanguageForLocale
                store.commit('location/setLanguage', lang)
                store.commit('location/setDeepLLanguage', lang)
            }
        },
    },
    computed: {
        smsLanguageForLocale() {
            const locale = this.$i18n?.locale || 'en'
            const map = { en: 'English', es: 'Spanish', fr: 'French', de: 'German', it: 'Italian' }
            return map[locale] || 'English'
        },
        languageItems() {
            const keys = { English: 'english', Spanish: 'spanish', French: 'french', Mandarin: 'mandarin', German: "german", Italian: "italian" }
            return this.languageValues.map(value => ({
                value,
                text: this.$t(`modals.languages.${keys[value]}`),
            }))
        },
        picked: {
            get() {
                return store.state.location.language
            },
            set(value) {
                store.commit(`location/setLanguage`, value)
                store.commit(`location/setDeepLLanguage` , value)
            }
        },
    }
})
</script>

<style>

.input-group-field {
    width: 100%;
    max-width: 45rem;
    /* height: 40px; */
    padding: 1em;
    margin: 1em auto;
    background-color: lightgray;
    color: black;
    box-shadow: 0px .25rem 1rem rgba(black, .50);
    border-radius: 5px;
    outline: none;
}

.numbers-container {
    overflow-y: auto;
    max-height: 300px;
    padding: 10px 24px 60px 24px !important;
}

.number-item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 8px 12px;
    margin-bottom: 6px;
    background-color: #f5f5f5;
    border-radius: 5px;
    /* border: 1px solid #e0e0e0; */
    transition: all 0.2s ease;
}

.number-item:last-child {
    margin-bottom: 0;
}

.number-text {
    font-size: 13px;
    font-weight: 500;
    color: #333;
    flex: 1;
    text-align: left;
    /* font-family: 'Roboto Mono', monospace; */
    letter-spacing: 0.3px;
}

.remove-number-btn {
    min-width: 20px !important;
    width: 20px !important;
    height: 20px !important;
    margin-left: 8px;
    padding: 0 !important;
    background-color: #ff5252 !important;
    color: white !important;
    border-radius: 50% !important;
    transition: all 0.2s ease;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
}

.remove-number-btn:hover {
    background-color: #ff1744 !important;
    transform: scale(1.1);
    box-shadow: 0 2px 8px rgba(255, 82, 82, 0.4);
}

.remove-x {
    color: white !important;
    font-size: 16px !important;
    font-weight: bold !important;
    line-height: 1 !important;
    display: block !important;
    margin: 0 !important;
    padding: 0 !important;
}

.v-dialog>.v-card>.v-card__text {
    padding: 0 24px 0 24px;
}



.empty-state-alert {
    font-size: 13px !important;
}

.message-type-section {
    padding: 20px 24px 12px 24px !important;
}

.message-type-container {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 10px;
    width: 100%;
}

.message-type-option {
    display: flex;
    align-items: center;
    cursor: pointer;
    padding: 8px 16px;
    border-radius: 4px;
    transition: all 0.2s ease;
    font-weight: 300;
}

.message-type-option:hover {
    background-color: rgba(0, 0, 0, 0.04);
    font-weight: 300;
}

.message-type-option.active {
    background-color: rgba(25, 118, 210, 0.08);
    font-weight: 300;
}

.message-type-radio {
    margin-right: 8px;
    cursor: pointer;
    font-weight: 300;
}

.message-type-label {
    font-size: 13px;
    font-weight: 500;
    color: #333;
    cursor: pointer;
    user-select: none;
}

.message-type-option.active .message-type-label {
    color: #1976d2;
    font-weight: 600;
}

</style>
